import createKeyFactory, { KEYS } from 'utils/createKeyFactory';

const shopsFactory = {
  ...createKeyFactory([KEYS.USERS]),
  shopStats: (id: string) => [...shopsFactory.details(id), 'stats'],
};

export const shopDeletionStatusesFactory = createKeyFactory([KEYS.SHOP_DELETION_STATUSES]);

export default shopsFactory;
